import { MouseEvent, ReactElement, useState } from 'react';
import { PoolButton } from '@synergy/components-next';
import { useTheme } from '@mui/material';

import { FavoriteHeartIcon } from './components/favorite-heart-icon';
import { FavoriteToolTip } from './components/favorite-tool-tip';

export interface FavoriteButtonProps {
    isFavorite: boolean;
    onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
}

export const FavoriteButton = (props: FavoriteButtonProps): ReactElement => {
    const [isFavorite, setIsFavorite] = useState(props.isFavorite ?? false);
    const theme = useTheme();

    const handleClick = (e: MouseEvent<HTMLButtonElement>): void => {
        e.stopPropagation();
        if (!isFavorite) {
            setIsFavorite(true);
            props.onClick?.(e);
        }
    };

    return (
        <FavoriteToolTip>
            <PoolButton
                variant="outlined"
                startIcon={
                    <FavoriteHeartIcon
                        isFavorite={isFavorite}
                        sx={{
                            color: isFavorite ? theme.palette.primary.main : theme.palette.grey[500],
                        }}
                    />
                }
                onClick={handleClick}
                sx={{
                    borderColor: isFavorite ? theme.palette.primary.main : theme.palette.grey[400],
                }}
                data-testid="favorite-button"
            />
        </FavoriteToolTip>
    );
};
